import produce from 'immer'
import { assign, findIndex, get, set } from 'lodash'

import { DICTIONARY_WORD_TYPES } from '../../constants'
import {
  DELETE_DICTIONARY_WORD,
  MOVE_DICTIONARY_WORD_TO_TYPE,
  UPDATE_DICTIONARY_WORD,
} from '../action-types'

const dictionaryWordReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_DICTIONARY_WORD.START:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.type}.fieldName`,
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: true,
            error: undefined,
          }),
        )
      })

    case UPDATE_DICTIONARY_WORD.COMPLETE:
      return produce(state, nextState => {
        const { updateDictionaryWord: updatedDictionaryWord } =
          action.payload.data

        const typeFieldNameToUpdate = get(
          DICTIONARY_WORD_TYPES,
          `${updatedDictionaryWord.type}.fieldName`,
        )
        const { total, results: typeListToUpdate } = get(
          nextState,
          `data.${typeFieldNameToUpdate}.data`,
        )

        const indexToUpdate = findIndex(
          typeListToUpdate,
          ({ id }) => id === updatedDictionaryWord.id,
        )

        typeListToUpdate[indexToUpdate] = {
          ...typeListToUpdate[indexToUpdate],
          ...updatedDictionaryWord,
        }

        return assign(
          nextState,
          set(nextState, `data.${typeFieldNameToUpdate}`, {
            isLoading: false,
            error: undefined,
            data: { total, results: typeListToUpdate },
          }),
        )
      })

    case UPDATE_DICTIONARY_WORD.FAIL:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.type}.fieldName`,
        )

        const { graphQLErrors, message } = action.error

        const errorDetails = get(
          graphQLErrors,
          '[0].extensions.exception.duplicated',
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: false,
            error: {
              errorDetails,
              message,
            },
          }),
        )
      })

    case DELETE_DICTIONARY_WORD.START:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.filters.type}.fieldName`,
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: true,
            error: undefined,
          }),
        )
      })

    case DELETE_DICTIONARY_WORD.COMPLETE:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.variables.filters.type}.fieldName`,
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            data: action.payload.data.deleteDictionaryWord,
            isLoading: false,
            error: undefined,
          }),
        )
      })

    case DELETE_DICTIONARY_WORD.FAIL:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.filters.type}.fieldName`,
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: false,
            error: action.error.message,
          }),
        )
      })

    case MOVE_DICTIONARY_WORD_TO_TYPE.START:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.type}.fieldName`,
        )

        const previousTypeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.previousType}.fieldName`,
        )

        const updatedState = assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: true,
            error: undefined,
          }),
        )

        return assign(
          updatedState,
          set(updatedState, `data.${previousTypeFieldName}`, {
            ...get(updatedState, `data.${previousTypeFieldName}`, {}),
            isLoading: true,
            error: undefined,
          }),
        )
      })

    case MOVE_DICTIONARY_WORD_TO_TYPE.COMPLETE:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.variables.type}.fieldName`,
        )

        const previousTypeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.variables.previousType}.fieldName`,
        )

        const updatedState = assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            data: get(
              action.payload.data.moveDictionaryWordToType,
              typeFieldName,
            ),
            isLoading: false,
            error: undefined,
          }),
        )

        return assign(
          updatedState,
          set(updatedState, `data.${previousTypeFieldName}`, {
            data: get(
              action.payload.data.moveDictionaryWordToType,
              previousTypeFieldName,
            ),
            isLoading: false,
            error: undefined,
          }),
        )
      })

    case MOVE_DICTIONARY_WORD_TO_TYPE.FAIL:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.type}.fieldName`,
        )

        const previousTypeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.previousType}.fieldName`,
        )

        const updatedState = assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: false,
            error: action.error.message,
          }),
        )

        const { graphQLErrors, message } = action.error

        const errorDetails = get(
          graphQLErrors,
          '[0].extensions.exception.duplicated',
        )

        return assign(
          updatedState,
          set(updatedState, `data.${previousTypeFieldName}`, {
            ...get(updatedState, `data.${previousTypeFieldName}`, {}),
            isLoading: false,
            error: {
              errorDetails,
              message,
            },
          }),
        )
      })

    default:
      return state
  }
}

export default dictionaryWordReducer
